import { useAdministrativeContext } from '../../../../../pages/administrativePanel/administrativePanelContext'
import { GroupsGraphic } from './groupsGraphic'
import { ProductsGraphic } from './productsGraphic'
import { useDispatch } from 'react-redux'
import { PaymentTypesGraphic } from './paymentTypesGraphic'
import { BsInfoCircle } from 'react-icons/bs'
import { CancellationsAndChargebacksGraphics } from './cancellations&ChargebacksGraphics'

import { Container, Card, Title } from './style'

export function QuantitativeDetails() {
    const { 
        startDate, 
        endDate, 
        listBusinessToFilter,
        listSalesChannelsId 
    } = useAdministrativeContext()

    const dispatch = useDispatch()


    return(

        <Container>
            <Card
                onClick={() => dispatch({
                     type: 'OPEN_CENTRALIZEDMODAL', 
                     title: "Vendas por grupo", 
                     componentToShow: 'groupsDetailedInformations',
                     datasComponent: { 
                        endDate, 
                        startDate, 
                        business: listBusinessToFilter,
                        salesChannels: listSalesChannelsId
                    } 
                })}
                 className="clickable"
            >
                 <BsInfoCircle />
                <Title>Grupos</Title>
                <GroupsGraphic />
            </Card>


            <Card 
                onClick={() => dispatch({
                    type: 'OPEN_CENTRALIZEDMODAL', 
                    title: "Produtos vendidos", 
                    componentToShow: 'productsDetailedInformations',
                    datasComponent: { 
                        endDate, 
                        startDate, 
                        business: listBusinessToFilter,
                        salesChannels: listSalesChannelsId
                    } 
                })}
                className="clickable"
            >
                <BsInfoCircle />
                <Title>Produtos</Title>
                <ProductsGraphic />
            </Card>


            <Card
                 onClick={() => dispatch({
                    type: 'OPEN_CENTRALIZEDMODAL', 
                    title: "Formas de pagamento", 
                    componentToShow: 'paymentTypesDetailed',
                    datasComponent: { 
                        endDate, 
                        startDate, 
                        business: listBusinessToFilter,
                        salesChannels: listSalesChannelsId
                    } 
                })}
                className="clickable"
            >
                <BsInfoCircle />
                <Title>Formas de Pagamento</Title>
                <PaymentTypesGraphic />
            </Card>


            <Card>
                <CancellationsAndChargebacksGraphics />
            </Card>

        </Container>

    )
}